import React from 'react';
import './Spinner.css';
/**
 * SVG Spinner.
 *
 * @param {object} props React component properties
 * @param {number} props.size
 */
export default function Spinner(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 16 : _ref$size;
  return /*#__PURE__*/React.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    className: "_dm-loading-spinner"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M7.5 0h1v5h-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C1C1C1",
    d: "M11.567.822l.866.5-2.5 4.33-.866-.5M14.678 3.567l.5.866-4.33 2.5-.5-.866M16 7.5v1h-5v-1M15.178 11.567l-.5.866-4.33-2.5.5-.866"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AAA",
    d: "M12.433 14.678l-.866.5-2.5-4.33.866-.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#919191",
    d: "M8.5 16h-1v-5h1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#787878",
    d: "M4.433 15.178l-.866-.5 2.5-4.33.866.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5F5F5F",
    d: "M1.322 12.433l-.5-.866 4.33-2.5.5.866"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#484848",
    d: "M0 8.5v-1h5v1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2F2F2F",
    d: "M.822 4.433l.5-.866 4.33 2.5-.5.866"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#171717",
    d: "M3.567 1.322l.866-.5 2.5 4.33-.866.5"
  })));
}